module.exports = __webpack_public_path__ + "img/promo-svg.ded8fe2b.svg";